export class PromiseCancelError extends Error {
  readonly isPromiseCancel = true;
}

export function isPromiseCancelError(error: Error) {
  return error instanceof PromiseCancelError && error.isPromiseCancel;
}
